import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/layout/Layout'
import { default as Login } from './app/login/page'
import { default as Dashboard } from './app/dashboard/page'
import { default as Companies } from './app/companies/page'
import { default as CompanyDetails } from './app/companies/[company_id]/page'
import { default as DomainDetails } from './app/companies/[company_id]/domains/[domain_id]/page'
import { default as CreateDomain } from './app/companies/[company_id]/domains/create/page'
import { default as Domains } from './app/domains/page'
import { default as DomainConnection } from './app/domains/connection/page'
import { default as FTP } from './app/ftp/page'
import { default as Settings } from './app/settings/page'
import { default as Users } from './app/users/page'
import { default as Versions } from './app/versions/page'
import { default as DeploymentBackup } from './app/deployment/backup/page'
import { default as DeploymentDelete } from './app/deployment/delete/page'
import { default as DeploymentDeploy } from './app/deployment/deploy/page'
import { default as DeploymentRecovery } from './app/deployment/recovery/page'
import { default as DeploymentUpgrade } from './app/deployment/upgrade/page'
import DocumentationPage from './app/documentation/page'
import DocumentationDetails from './app/documentation/[documentation_id]/page'
import Requisitions from './app/requisitions/page'
import CronjobPage from './app/cronjob/page'

function App() {
  return (
    <Routes>
      {/* Redirect root to login */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      
      {/* Login route (no layout) */}
      <Route path="/login" element={<Login />} />
      
      {/* Protected routes with layout */}
      <Route path="/*" element={
        <Layout>
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/companies/:company_id" element={<CompanyDetails />} />
            <Route path="/companies/:company_id/domains/:domain_id" element={<DomainDetails />} />
            <Route path="/companies/:company_id/domains/create" element={<CreateDomain />} />
            <Route path="/domains" element={<Domains />} />
            <Route path="/domains/connection" element={<DomainConnection />} />
            <Route path="/ftp" element={<FTP />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/users" element={<Users />} />
            <Route path="/versions" element={<Versions />} />
            <Route path="/deployment/backup" element={<DeploymentBackup />} />
            <Route path="/deployment/delete" element={<DeploymentDelete />} />
            <Route path="/deployment/deploy" element={<DeploymentDeploy />} />
            <Route path="/deployment/recovery" element={<DeploymentRecovery />} />
            <Route path="/deployment/upgrade" element={<DeploymentUpgrade />} />
            <Route path="/documentation" element={<DocumentationPage />} />
            <Route path="/documentation/:documentation_id" element={<DocumentationDetails />} />
            <Route path='/requisitions' element={<Requisitions />} />
            <Route path='/cronjob' element={<CronjobPage />} />
          </Routes>
        </Layout>
      } />
    </Routes>
  )
}

export default App
